:host:not(:empty){margin-top:15px;display:block}
/*# sourceMappingURL=sampling-workspace-header.component.css.map */
